// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Open_Sans_3b8b84'","fontStyle":"normal"},"className":"__className_3b8b84","variable":"__variable_3b8b84"};